import styled from "styled-components";
import { white } from "@carbon/colors";

export const StyledEducationItem = styled.li`
  margin-top: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${white};
`;

export const StyledInstitute = styled.h4`
  font-weight: bold;
`;

export const StyledDegree = styled.p`
  font-weight: bold;
  display: inline-block;
`;
